import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import MarvelLink from '@marvelapp/marvel-ui/link';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import { PopoverOption } from '@marvelapp/marvel-ui/popover';

import ArrowRight from 'marketing-website/components/icons/ArrowRight';

import general from './style/general.module.css';

export default function NavFooter({ children, url }) {
  return (
    <div className={general.footer}>
      <PopoverOption key="key" size="medium">
        <InlineGrid size="xs">
          <Link to={url}>
            <MarvelLink type="blue">{children}</MarvelLink>
          </Link>
          <ArrowRight color="blue" height="8" />
        </InlineGrid>
      </PopoverOption>
    </div>
  );
}

NavFooter.propTypes = {
  url: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavDropdownFooter/index.js